import { cellTypes } from 'core/table';
import { getCampaignName, getCampaignUrl } from 'utils/campaigns';
import { getNewDate, DATE_FORMAT_FULL_WITH_TIME } from 'utils/date';
import { CampaignTableAnchor } from '../../Dashboard.styled';

export const ID = {
  name: 'Id',
  sortable: true,
  type: cellTypes.TEXT,
  value: 'id',
  minWidth: 50,
  maxWidth: 80,
};

export const NAME = {
  name: 'Name',
  getCellContent: (props) => {
    const campaign = (props && props.rowData) || {};
    const url = getCampaignUrl(campaign, true);
    const name = getCampaignName(campaign);
    return <CampaignTableAnchor href={url}>{name}</CampaignTableAnchor>;
  },
  sortable: true,
  title: true,
  type: cellTypes.CUSTOM,
  value: 'name',
  minWidth: 120,
};

export const STATE = {
  name: 'State',
  sortable: true,
  type: cellTypes.TEXT,
  value: 'campaignState',
  minWidth: 80,
  maxWidth: 100,
};

export const MEDIUM = {
  name: 'Medium',
  sortable: true,
  type: cellTypes.TEXT,
  value: 'messageMedium',
  minWidth: 80,
  maxWidth: 100,
};

export const CREATED = {
  name: 'Created',
  formatter: (value) => getNewDate({ date: value }).format(DATE_FORMAT_FULL_WITH_TIME),
  sortable: true,
  type: cellTypes.TEXT,
  value: 'createdAt',
  minWidth: 160,
  maxWidth: 180,
};

export const UPDATED = {
  name: 'Updated',
  formatter: (value) => getNewDate({ date: value }).format(DATE_FORMAT_FULL_WITH_TIME),
  sortable: true,
  type: cellTypes.TEXT,
  value: 'updatedAt',
  minWidth: 160,
  maxWidth: 180,
};
